import { render, staticRenderFns } from "./index.vue?vue&type=template&id=58db60c9&scoped=true&lang=pug&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=58db60c9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58db60c9",
  null
  
)

/* custom blocks */
import block0 from "~/lang/guaranteedIrish?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Fubuntu%2Fnuxt%2Fbonkers%2Freleases%2F20230324173659%2Fpages%2Fguaranteed-irish%2Findex.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {WidgetsImage: require('/home/ubuntu/nuxt/bonkers/releases/20230324173659/components/widgets/image.vue').default,SiteFeefo: require('/home/ubuntu/nuxt/bonkers/releases/20230324173659/components/site/feefo.vue').default})
